import { render, staticRenderFns } from "./user.component.vue?vue&type=template&id=d6b628b4&scoped=true&"
import script from "./user.component.js?vue&type=script&lang=js&"
export * from "./user.component.js?vue&type=script&lang=js&"
import style0 from "./user.component.scss?vue&type=style&index=0&id=d6b628b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b628b4",
  null
  
)

export default component.exports